// `image.layer_edit`: live's layer editor's "Edit with AI" (G13b, #251), one layer edited.
// The editor's AI edit modal builds the body (PR E); never a Studio draft.
import { ImageLayerEditQuote, ImageLayerEditRequest } from "../../../api/generated/zod";
import type { JobTypeModule } from "./contract";

export const jobType: JobTypeModule<"image.layer_edit"> = {
  type: "image.layer_edit",
  label: "AI layer edit",
  source: "form",
  pair: "image.layer_edit",
  fields: () => ({}),
  request: ImageLayerEditRequest,
  quote: ImageLayerEditQuote,
};
